import * as api from '@/api/give-course/yxTask'
import * as TYPES from './type';

export default {
  //授课签到
  async getSKTaskList({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKTaskList(paramets)
    commit(TYPES.SK_YXTASK_LIST, { result })
    cb && cb()
  },
  //预习详情
  async getSKTaskDetails({ commit, state }, { paramets, cb}) {
    const result = await api.reqTaskDetails(paramets)
    commit(TYPES.SK_YXTASK_DETAILS, { result })
    cb && cb()
  },
  //预习测验详情
  async getSKTestListDetail({ commit, state }, { paramets, cb}) {
    const result = await api.reqTestListDetail(paramets)
    commit(TYPES.SK_YXTASK_LISTDETAIL, { result })
    cb && cb()
  },
  //学生疑惑留言
  async getSKsturootMessage({ commit, state }, { paramets, cb}) {
    const result = await api.reqStuRootMessage(paramets)
    commit(TYPES.SK_YXTASK_STUROOTMESSAGE, { result })
    cb && cb()
  },
}
